import { assertEvent } from 'xstate5';

import { type DeliveryOrderDetailInput } from '@sg/graphql-schema';

import { type AddUpsellToBagParams } from './ordering-machine.actors';
import { type OrderingContext } from './ordering-machine.context';
import { type OrderingEvent } from './ordering-machine.events';

// ─────────────────────────────────────────────────────────────────────────────

export type OrderingMachineInput<InputType extends Record<string, unknown> | void = void> = (args: {
  context: OrderingContext;
  event: OrderingEvent;
}) => InputType;

// ─────────────────────────────────────────────────────────────────────────────

export const getAddUpsellToBagInput: OrderingMachineInput<AddUpsellToBagParams> = ({
  context,
  event,
}) => {
  assertEvent(event, 'ADD_UPSELL_TO_BAG');

  const { deliveryOrderDetail } = context.cart;
  const deliveryDetails: DeliveryOrderDetailInput | undefined = deliveryOrderDetail
    ? { ...deliveryOrderDetail, addressId: deliveryOrderDetail.address?.id ?? '' }
    : undefined;

  return {
    productId: event.params.productId,
    productName: event.params.productName,
    quantity: event.params.quantity,
    placementVariation: event.params.placementVariation,
    deliveryDetails,
    cart: context.cart,
  };
};
